var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPin12Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/pin") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/pin",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(2.000000, 0.000000)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4,0 C1.78783343,0 0,1.8321437 0,4.08637874 C0,4.88641806 0.443485784,6.09540618 1.22713966,7.66057181 C1.40703398,8.0198687 1.60263938,8.39263782 1.81156684,8.77593716 C2.19862382,9.48603379 2.61277779,10.1989459 3.02690389,10.8805477 L3.30206975,11.328609 L3.58104534,11.7716086 C3.77731895,12.0761305 4.22268105,12.0761305 4.41895466,11.7716086 L4.8317042,11.1120066 L4.97309611,10.8805477 C5.38722221,10.1989459 5.80137618,9.48603379 6.18843316,8.77593716 C6.39736062,8.39263782 6.59296602,8.0198687 6.77286034,7.66057181 L7.05058337,7.09043358 L7.29520489,6.55430542 C7.75053925,5.51647142 8,4.68640823 8,4.08637874 C8,1.83229895 6.21185038,0 4,0 Z M4,0.996677741 C5.65576792,0.996677741 7.00317173,2.37734889 7.00317173,4.08637874 C7.00317173,4.52923329 6.77375655,5.26535642 6.35789967,6.20721497 L6.13463337,6.69488362 L5.88148716,7.21441002 C5.70703836,7.56283077 5.516768,7.9254328 5.3131527,8.29898643 L4.92605443,8.99438244 C4.75082783,9.30297196 4.57196281,9.6101535 4.39188132,9.9128304 L4.00027186,10.5607973 L3.87885053,10.3630802 C3.47229245,9.69393446 3.06576223,8.99414561 2.6868473,8.29898643 C2.483232,7.9254328 2.29296164,7.56283077 2.11851284,7.21441002 C1.98466871,6.94708762 1.8615819,6.69080008 1.74992388,6.44691511 L1.54204518,5.97608714 C1.18960075,5.14470582 0.996828274,4.49232874 0.996828274,4.08637874 C0.996828274,2.37717366 2.34393699,0.996677741 4,0.996677741 Z",
    id: "Stroke-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4,2 C2.89550467,2 2,2.89571086 2,4 C2,5.10464244 2.89535756,6 4,6 C5.10428914,6 6,5.10449533 6,4 C6,2.89585801 5.10414199,2 4,2 Z M4,2.99728015 C4.55335937,2.99728015 5.00271985,3.44664063 5.00271985,4 C5.00271985,4.55366131 4.55355792,5.00271985 4,5.00271985 C3.44614017,5.00271985 2.99728015,4.55385983 2.99728015,4 C2.99728015,3.44644208 3.44633869,2.99728015 4,2.99728015 Z",
    id: "Stroke-3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin12Px);
export default __webpack_public_path__ + "static/media/pin_12px.35426095.svg";
export { ForwardRef as ReactComponent };